import { Preferences, Account, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getUserPreferences(httpClient: HttpClient) {
  return (account: Identifiable<Account>) =>
    new Promise<Preferences>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Account>({
          endpoint: `/api/users/${account.uuid}`,
          method: HttpMethods.GET,
        })
        .then(({ preferences }) => resolve(preferences))
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { getUserPreferences };
